import { TransactionTypeChar, orderSideTypeCharMap, transactionTypeCharMap } from '@tassat/common-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';

export const getTransactionTypeString = (transaction: TransactionHistoryRecord) => {
    let tranType: string = (transactionTypeCharMap(transaction.type) as string);

    if (transaction.OrderSide && transaction.type === TransactionTypeChar.order) {
        tranType = orderSideTypeCharMap(transaction.OrderSide.trim()
            .toUpperCase());
    }

    return tranType;
};